import { MbscCalendarInvalid } from '@mobiscroll/react';

import { DispatchAssignmentRead } from 'src/common/external/bambi-api/bambiApi';

export const createClockInEventsFromAssignments = (
  assignments: DispatchAssignmentRead[]
): MbscCalendarInvalid[] => {
  const clockInEvents: MbscCalendarInvalid[] = assignments
    .map((assignment) => {
      if (!assignment.clocked_in_at) {
        return {};
      }
      return {
        id: `clock-in-${assignment.id}`,
        start: assignment.clocked_in_at,
        end: assignment.clocked_in_at,
        title: 'Clock In',
        resource: assignment.id,
        assignmentEvent: {
          type: 'clock-in',
        },
      };
    })
    .filter((x) => !!x.start);
  return clockInEvents;
};
